<template>
  <div class="open-buy">
    <div class="open-buy-main">
      <!-- <div class="bg">
        <img
          @click="gotoBuy(0, 1)"
          class="img"
          src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/open-buy/301.png"
        />
        <img
          @click="gotoBuy(0, 2)"
          class="img"
          src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/open-buy/302.png"
        />
      </div> -->
      <div class="cnt">
        <img
          class="img"
          src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/open-buy/401.png"
        />
      </div>
    </div>
    <div class="open-buy-footer">
      <div class="btn-bg" @click="gotoBuy(0, 2)">
        <!-- <div class="l" @click="gotoBuy(0, 1)"></div>
        <div class="r" @click="gotoBuy(0, 2)"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: "开通业务",
    };
  },
  methods: {
    gotoBuy(selfType, packageType) {
      app.teacher.gotoOpenBuy({
        selfType,
        packageType,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.open-buy {
  display: flex;
  flex-direction: column;
}
.open-buy-main {
  flex: 1;
  overflow: auto;
  // .bg {
  //   padding: 3.2vw 4.27vw 0;
  //   height: 46.67vw;
  //   background: linear-gradient(180deg, #3e4257 0%, #252532 100%);
  //   display: flex;
  //   justify-content: space-between;
  //   .img {
  //     width: 44.27vw;
  //     height: 34.93vw;
  //   }
  // }
  .cnt {
    display: flex;
    justify-content: center;
    .img {
      width: 100vw;
      height: 440vw;
      // margin-top: -4.8vw;
    }
  }
}
.open-buy-footer {
  padding-top: 3.2vw;
  padding-bottom: 2.135vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-bg {
    width: 91.47vw;
    height: 13.87vw;
    background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/open-buy/402.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: scroll;
    display: flex;
    .l,
    .r {
      flex: 1;
    }
  }
}
</style>